import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { inject } from '@angular/core';
import {
  CommunicationService,
  FrameMessageType,
} from 'src/app/shared/services/communication.service';

/**
 * JWT Interceptor function
 * Adds an Authorization header with JWT if the user is logged in
 * and the request is to an API URL.
 */
export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const communicationService = inject(CommunicationService);

  const token = communicationService.token();

  const isLoggedIn = token;
  const isApiUrl =
    req.url.startsWith(environment.mainapiUrl) ||
    req.url.startsWith(environment.messagingUrl) ||
    req.url.startsWith(environment.dispatchUrl) ||
    req.url.startsWith(environment.BIUrl);
  if (isLoggedIn && isApiUrl) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        environmentType: environment.environmentType,
      },
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        communicationService.sendMessageToParent(FrameMessageType.UNAUTHORIZED);
        return throwError(() => new Error('Error happened'));
      }
      return throwError(() => new Error('Error happened'));
    }),
  );
};
